import type { IconProps } from '@chakra-ui/icon';
import { createIcon } from '@chakra-ui/icon';
import type { ComponentWithAs } from '@chakra-ui/system';
import React from 'react';
import { IconType } from 'react-icons';
import { FaApple } from "react-icons/fa";
import { RiNextjsFill } from "react-icons/ri";
import { BiLogoNetlify } from "react-icons/bi";
import { SiGo } from "react-icons/si";

const UrlEndpointsSidebarGraphic = createIcon({
  path: (
    <g transform="translate(-535 -463.54)">
      <circle
        transform="translate(535 463.54)"
        cx="50.5"
        cy="50.5"
        r="50.5"
        fill="#eaf4fe"
        opacity=".53"
      />
      <g transform="translate(.181 74.764)">
        <path
          fill="#d6ebff"
          transform="translate(-9959 -387)"
          d="m10547 776.93-3.354 1.341-6.131 28.836 2.107 2.778 21.938 4.886 3.353-2.012 6.132-27.59-1.629-2.491z"
        />
        <path
          fill="#d6ebff"
          transform="rotate(35.02 6108.2 -15198)"
          d="m10547 776.93-3.354 1.341-6.131 28.836 2.107 2.778 21.938 4.886 3.353-2.012 6.132-27.59-1.629-2.491z"
        />
        <g transform="translate(522.33 322.19)">
          <g transform="translate(27.672 66.583)">
            <path
              fill="#2c93fa"
              transform="translate(-110.8 -447.5)"
              d="M130.675 529.667a4.642 4.642 0 0 1-3.3-1.365l-15.209-15.209a4.676 4.676 0 0 1 0-6.6l18.925-18.925a4.676 4.676 0 0 1 6.6 0l15.209 15.206a4.67 4.67 0 0 1 0 6.594l-18.935 18.944a4.65 4.65 0 0 1-3.29 1.355zm3.708-40.691a1.853 1.853 0 0 0-1.337.553l-18.926 18.926a1.884 1.884 0 0 0-.553 1.337 1.853 1.853 0 0 0 .553 1.337l15.209 15.209a1.9 1.9 0 0 0 2.684 0l18.925-18.907a1.893 1.893 0 0 0 0-2.675l-15.209-15.227a1.929 1.929 0 0 0-1.346-.553z"
            />
            <path
              fill="#2c93fa"
              transform="translate(-375.94 -66.583)"
              d="M428.505 106.833a4.62 4.62 0 0 1-1.061-.12l-20.954-4.86a4.664 4.664 0 0 1-3.486-5.6l6.05-26.064a4.664 4.664 0 0 1 5.6-3.486l20.954 4.86a4.664 4.664 0 0 1 3.486 5.6l-6.05 26.064a4.641 4.641 0 0 1-2.075 2.905 4.724 4.724 0 0 1-2.464.701zm-14.923-37.5a1.89 1.89 0 0 0-1.845 1.466l-6.05 26.073a1.894 1.894 0 0 0 1.42 2.278l20.954 4.86a1.906 1.906 0 0 0 2.278-1.42l6.05-26.064a1.894 1.894 0 0 0-1.42-2.278l-20.954-4.86a1.8 1.8 0 0 0-.432-.055z"
            />
            <path
              fill="#2c93fa"
              transform="rotate(13.056 -82.464 199)"
              d="M0 0h2.767v16.924H0z"
            />
            <path
              fill="#2c93fa"
              transform="rotate(45 -36.06 65.277)"
              d="M0 0h2.767v16.924H0z"
            />
            <path
              fill="#2c93fa"
              transform="rotate(50.921 -5.02 24.61)"
              d="M0 0h8.264v2.767H0z"
            />
            <path
              fill="#2c93fa"
              transform="rotate(32.97 -62.654 134.96)"
              d="M0 0h8.264v2.767H0z"
            />
            <path
              fill="#2c93fa"
              transform="rotate(14.916 -115.5 38.122)"
              d="M0 0h8.264v2.767H0z"
            />
            <path
              fill="#2c93fa"
              transform="rotate(86.973 16.24 58.543)"
              d="M0 0h2.767v8.264H0z"
            />
            <path
              fill="#2c93fa"
              transform="rotate(68.973 -22.58 69.708)"
              d="M0 0h8.264v2.767H0z"
            />
          </g>
        </g>
      </g>
    </g>
  ),
  viewBox: '0 0 101 101',
})

const UrlEndpointsHomeGraphic = createIcon({
  path: (
    <g transform="translate(-1228.1 -267.42)">
      <g transform="translate(1228.1 267.42)">
        <path
          fill="#e2ebff"
          transform="translate(-77.447 -64.192)"
          d="m88.068 98.779 1.507-2.488c12.683-20.9 35.625-33.5 59.8-31.975a63.373 63.373 0 0 1 9.257 1.268c21.989 4.709 41.119 21.337 49.051 42.626 4.66 12.522 5.963 26.943 14.813 36.887 11.52 12.936 31.07 13.314 48.266 12.8s36.753-.077 48.217 12.908c7.175 8.171 9.46 19.712 8.878 30.594-1.528 28.842-21.625 54.657-47.18 67.446s-55.645 13.966-83.618 8.325c-39.185-7.9-76.443-29.585-98.845-63.066S70.15 134.944 88.068 98.779z"
        />
        <circle
          fill="#e2ebff"
          transform="translate(193.06 1.079)"
          cx="24.296"
          cy="24.296"
          r="24.296"
        />
        <circle
          fill="#e2ebff"
          transform="translate(193.06 199.89)"
          cx="24.296"
          cy="24.296"
          r="24.296"
        />
      </g>
      <g transform="translate(1441.8 381.15)" opacity=".84">
        <path
          fill="#fdb400"
          transform="translate(-45.074 -302.79)"
          d="M86.236 397.735a7.428 7.428 0 0 0-.824-5.735 13.05 13.05 0 0 0-4.15-4.2c-3.192-2.142-7.531-2.99-11.364-3.186.055 4.272 3.3 8 5.065 9.765 2.8 2.832 9.557 6.249 11.272 3.326"
        />
        <path
          fill="#fdb400"
          transform="translate(-58.444 -294.63)"
          d="M80.87 369.525a6.3 6.3 0 0 0 5.889 2.331 8.362 8.362 0 0 0 5.493-3.454 3.5 3.5 0 0 0 .83-2.856 2.685 2.685 0 0 0-2.057-1.8 5.42 5.42 0 0 0-2.832.25c-3.131.989-5.987 2.521-7.324 5.529"
        />
        <path
          fill="#263238"
          transform="translate(-78.328 -295.54)"
          d="M89.159 366a4.61 4.61 0 0 0 .671.421l1.87 1.079a22.186 22.186 0 0 0 6.615 2.71 13.475 13.475 0 0 0 7.079-.354 9.155 9.155 0 0 0 1.953-.94c.22-.134.372-.262.482-.342s.159-.128.153-.134a15.06 15.06 0 0 1-2.649 1.221 14.09 14.09 0 0 1-6.963.269 23.907 23.907 0 0 1-6.536-2.624c-.8-.421-1.452-.769-1.9-.995a4.266 4.266 0 0 0-.775-.311z"
        />
        <path
          fill="#263238"
          transform="translate(-67.972 -295.3)"
          d="M104.21 387.184a1.541 1.541 0 0 0-.232-.256c-.189-.171-.421-.4-.714-.677-.61-.61-1.532-1.428-2.661-2.441-2.27-2.057-5.438-4.882-9.008-7.861s-6.86-5.664-9.27-7.543c-1.221-.946-2.185-1.7-2.874-2.215l-.787-.61a1.86 1.86 0 0 0-.293-.189 1.442 1.442 0 0 0 .256.238l.757.61 2.82 2.283c2.374 1.922 5.645 4.6 9.215 7.6s6.756 5.78 9.051 7.794l2.746 2.411.745.641a1.964 1.964 0 0 0 .249.215z"
        />
        <path
          fill="#fdb400"
          transform="translate(-90.255 -300.02)"
          d="M107.329 377.656a14.757 14.757 0 0 1 3.015 13.14c-.305 1.154-.958 2.441-2.136 2.594s-2.148-.928-2.716-1.977a12.609 12.609 0 0 1 1.55-13.9"
        />
        <path
          fill="#263238"
          transform="translate(-95.837 -296.04)"
          d="M113.5 384.077a3.666 3.666 0 0 0 .22-.714 7.233 7.233 0 0 0 .183-.854c.049-.336.14-.714.171-1.141a12.383 12.383 0 0 0 .079-1.4 14.652 14.652 0 0 0-.049-1.611 16.481 16.481 0 0 0-.751-3.619 16.251 16.251 0 0 0-1.611-3.332 12.566 12.566 0 0 0-.952-1.3 11.691 11.691 0 0 0-.934-1.05 10.744 10.744 0 0 0-.848-.793 6.1 6.1 0 0 0-.677-.543 3.359 3.359 0 0 0-.61-.415c-.043.049.836.653 2 1.886a12.645 12.645 0 0 1 .9 1.056 15.552 15.552 0 0 1 .915 1.3 16.536 16.536 0 0 1 1.556 3.283 17.038 17.038 0 0 1 .763 3.552c.043.555.085 1.086.073 1.587a12.44 12.44 0 0 1-.049 1.385c-.144 1.685-.43 2.711-.379 2.723z"
        />
        <path
          transform="translate(-20.281 -250.54)"
          d="M25.461 309.844c-7.873-10.845-5.578-25.12-.983-37.082.769-2 1.282-4.2 2.856-5.645s4.235-1.874 5.749-.4c1.257 1.221 1.306 3.192 1.648 4.925a12.5 12.5 0 0 0 3.169 6.168c1.056 1.111 2.508 2.075 4.022 1.831 2.075-.36 3.112-2.7 3.8-4.712l3.808-11.29a19.745 19.745 0 0 1 2.673-5.755 6.609 6.609 0 0 1 5.371-2.862c2.093.122 4.083 2.044 3.808 4.15a19.533 19.533 0 0 1-.812 2.521 2.293 2.293 0 0 0 .549 2.441 2.536 2.536 0 0 0 2.527-.165 28.844 28.844 0 0 0 7.323-5.578 39.931 39.931 0 0 1 7.061-5.926c2.649-1.556 5.853-2.441 8.788-1.587s5.383 3.662 5.133 6.713-2.893 5.389-5.493 7.061a47.484 47.484 0 0 1-12.432 5.7 3.93 3.93 0 0 0-2.142 1.141c-.9 1.19-.092 2.96 1.08 3.857 1.324 1.013 3 1.422 4.5 2.148s2.96 2 3.051 3.662c.11 2.344-2.35 3.9-4.528 4.724a40.652 40.652 0 0 1-13.64 2.637 13.3 13.3 0 0 0-4.937.61c-1.55.647-2.893 2.185-2.661 3.845s1.922 2.758 3.57 3.009a28.528 28.528 0 0 0 4.992-.159c3.119-.092 6.622 1.336 7.562 4.333a6.675 6.675 0 0 1-1.263 5.859 15.6 15.6 0 0 1-4.766 3.912 40.889 40.889 0 0 1-20.506 5.889c-7.171 0-13.317-1.446-18.876-5.975"
          fill="#2fbc87"
        />
        <path
          fill="#263238"
          transform="translate(-18.861 -252.65)"
          d="M23.54 315.59c2.093-4.644 2.344-4.669 6.249-10.149a190.736 190.736 0 0 1 13.847-16.917l3.857-4.242c1.269-1.391 2.527-2.771 3.845-4.046a94.828 94.828 0 0 1 7.97-6.884c2.643-2.069 5.224-3.93 7.653-5.657s4.73-3.283 6.884-4.62a75.359 75.359 0 0 1 10.625-5.535c1.3-.549 2.319-.946 3.021-1.221l.793-.293.275-.085a1.533 1.533 0 0 1-.262.122l-.781.329c-.684.281-1.7.7-2.99 1.276a79.513 79.513 0 0 0-10.54 5.633c-2.136 1.349-4.418 2.917-6.841 4.651s-4.986 3.607-7.616 5.676A96.67 96.67 0 0 0 51.6 280.5c-1.306 1.269-2.551 2.636-3.82 4.034l-3.862 4.266a194.912 194.912 0 0 0-13.841 16.856c-3.912 5.456-4.174 5.444-6.292 10.058"
        />
        <path
          fill="#263238"
          transform="translate(-44.003 -253.41)"
          d="M76.59 281.024a4.688 4.688 0 0 1 .1-.928c.085-.61.244-1.446.446-2.5.409-2.093 1.068-4.974 1.831-8.147s1.358-6.049 1.733-8.149c.189-1.05.336-1.9.427-2.49a4.691 4.691 0 0 1 .189-.909 3.972 3.972 0 0 1-.037.928 43.15 43.15 0 0 1-.305 2.514c-.305 2.118-.885 5.023-1.629 8.2s-1.41 5.963-1.922 8.123c-.22.977-.409 1.831-.561 2.441a4.506 4.506 0 0 1-.272.917z"
        />
        <path
          fill="#263238"
          transform="translate(-6.684 -268.14)"
          d="M66.772 299.851a6.373 6.373 0 0 1-1.068-.232c-.684-.171-1.672-.421-2.9-.7-2.441-.562-5.871-1.221-9.673-1.782s-7.269-.909-9.765-1.092c-1.257-.1-2.276-.159-2.978-.2a6.162 6.162 0 0 1-1.093-.1 5.2 5.2 0 0 1 1.1-.055c.708 0 1.733 0 2.99.073 2.527.116 6.011.427 9.826.983a95.344 95.344 0 0 1 9.679 1.9c1.221.305 2.2.61 2.881.818a5.7 5.7 0 0 1 1.007.378z"
        />
        <path
          fill="#263238"
          transform="translate(-109.25 -260.08)"
          d="M120.664 312.51a1.47 1.47 0 0 1-.067-.378c-.037-.293-.073-.653-.122-1.086-.1-.946-.207-2.313-.317-4.01-.22-3.393-.384-8.086-.488-13.262s-.226-9.874-.378-13.262a736.37 736.37 0 0 0-.2-4.016 8.164 8.164 0 0 0-.043-1.092 1.171 1.171 0 0 1 0-.385 1.473 1.473 0 0 1 .067.378c0 .293.067.647.116 1.086.1.94.207 2.313.317 4.01.226 3.387.384 8.08.494 13.268s.226 9.869.372 13.256c.079 1.648.146 3.009.2 4.016a8.15 8.15 0 0 0 .043 1.093 1.7 1.7 0 0 1 .006.384z"
        />
        <path
          fill="#263238"
          transform="translate(-45.119 -284.01)"
          d="M94.685 337.241a1.706 1.706 0 0 1-.391 0h-1.116l-4.083-.079c-3.454-.067-8.221-.1-13.494-.14s-10.045-.116-13.494-.25c-1.727-.067-3.125-.14-4.083-.207l-1.111-.085a1.589 1.589 0 0 1-.384-.055 1.763 1.763 0 0 1 .391 0h1.111l4.089.079c3.448.067 8.221.1 13.487.14s10.045.11 13.494.25c1.727.067 3.125.134 4.089.208l1.1.079a1.218 1.218 0 0 1 .395.06z"
        />
      </g>
      <g transform="translate(1235.5 515.98)">
        <path
          fill="#263238"
          transform="translate(-37.35 -471.48)"
          d="M37.35 471.515c0 .085 59.906.3 133.794.47s133.8.238 133.8.146-59.894-.293-133.8-.464-133.794-.244-133.794-.152z"
        />
      </g>
      <g transform="translate(749.48 -7.626)">
        <path
          fill="#fff"
          transform="translate(-9943.7 -386.44)"
          d="m10552 776.93-4.962 1.985-9.073 42.673 3.118 4.111 32.466 7.23 4.962-2.977 9.074-40.83-2.411-3.686z"
        />
        <path
          fill="#fff"
          transform="rotate(35.02 -408.48 1137.1)"
          d="M14.035 0 9.073 1.985 0 44.658l3.118 4.111L35.584 56l4.962-2.977 9.075-40.83-2.412-3.687z"
        />
        <g transform="translate(551.61 388.77)">
          <g>
            <path
              fill="#2c93fa"
              transform="translate(-110.8 -428.93)"
              d="M140.213 550.526a6.87 6.87 0 0 1-4.886-2.02L112.82 526a6.92 6.92 0 0 1 0-9.772l28.007-28.007a6.92 6.92 0 0 1 9.772 0l22.507 22.507a6.911 6.911 0 0 1 0 9.759l-28.021 28.034a6.881 6.881 0 0 1-4.872 2.005zm5.487-60.218a2.743 2.743 0 0 0-1.979.819l-28.007 28.007a2.789 2.789 0 0 0-.819 1.979 2.743 2.743 0 0 0 .819 1.979L138.22 545.6a2.817 2.817 0 0 0 3.972 0l28.007-27.98a2.8 2.8 0 0 0 0-3.958l-22.507-22.534a2.854 2.854 0 0 0-1.992-.82z"
            />
            <path
              fill="#2c93fa"
              transform="translate(-363.02 -66.583)"
              d="M440.8 126.148a6.838 6.838 0 0 1-1.57-.177l-31.01-7.193a6.9 6.9 0 0 1-5.159-8.285l8.953-38.571a6.9 6.9 0 0 1 8.285-5.159l31.01 7.193a6.9 6.9 0 0 1 5.159 8.285l-8.953 38.571a6.868 6.868 0 0 1-3.071 4.3 6.991 6.991 0 0 1-3.644 1.036zm-22.083-55.5a2.8 2.8 0 0 0-2.73 2.17l-8.953 38.585a2.8 2.8 0 0 0 2.1 3.371l31.01 7.193a2.82 2.82 0 0 0 3.371-2.1L452.47 81.3a2.8 2.8 0 0 0-2.1-3.371l-31.01-7.193a2.667 2.667 0 0 0-.643-.084z"
            />
            <path
              fill="#2c93fa"
              transform="rotate(13.056 -122.04 294.49)"
              d="M0 0h4.095v25.045H0z"
            />
            <path
              fill="#2c93fa"
              transform="rotate(45 -53.362 96.6)"
              d="M0 0h4.095v25.045H0z"
            />
            <path
              fill="#2c93fa"
              transform="rotate(50.921 -7.427 36.42)"
              d="M0 0h12.229v4.095H0z"
            />
            <path
              fill="#2c93fa"
              transform="rotate(32.97 -92.72 199.72)"
              d="M0 0h12.229v4.095H0z"
            />
            <path
              fill="#2c93fa"
              transform="rotate(14.916 -170.92 56.419)"
              d="M0 0h12.229v4.095H0z"
            />
            <path
              fill="#2c93fa"
              transform="rotate(86.973 24.031 86.636)"
              d="M0 0h4.095v12.229H0z"
            />
            <path
              fill="#2c93fa"
              transform="rotate(68.973 -33.417 103.16)"
              d="M0 0h12.229v4.095H0z"
            />
          </g>
        </g>
      </g>
    </g>
  ),
  viewBox: '0 0 285.39 249.26',
})

const sdkIcons: {
  [sdkName: string]: ComponentWithAs<'svg', IconProps> | IconType
} = {
  react: createIcon({
    viewBox: '0 0 128 128',
    displayName: 'ReactIcon',
    d: 'M107.3 45.2c-2.2-.8-4.5-1.6-6.9-2.3.6-2.4 1.1-4.8 1.5-7.1 2.1-13.2-.2-22.5-6.6-26.1-1.9-1.1-4-1.6-6.4-1.6-7 0-15.9 5.2-24.9 13.9-9-8.7-17.9-13.9-24.9-13.9-2.4 0-4.5.5-6.4 1.6-6.4 3.7-8.7 13-6.6 26.1.4 2.3.9 4.7 1.5 7.1-2.4.7-4.7 1.4-6.9 2.3-12.5 4.8-19.3 11.4-19.3 18.8s6.9 14 19.3 18.8c2.2.8 4.5 1.6 6.9 2.3-.6 2.4-1.1 4.8-1.5 7.1-2.1 13.2.2 22.5 6.6 26.1 1.9 1.1 4 1.6 6.4 1.6 7.1 0 16-5.2 24.9-13.9 9 8.7 17.9 13.9 24.9 13.9 2.4 0 4.5-.5 6.4-1.6 6.4-3.7 8.7-13 6.6-26.1-.4-2.3-.9-4.7-1.5-7.1 2.4-.7 4.7-1.4 6.9-2.3 12.5-4.8 19.3-11.4 19.3-18.8s-6.8-14-19.3-18.8zm-14.8-30.5c4.1 2.4 5.5 9.8 3.8 20.3-.3 2.1-.8 4.3-1.4 6.6-5.2-1.2-10.7-2-16.5-2.5-3.4-4.8-6.9-9.1-10.4-13 7.4-7.3 14.9-12.3 21-12.3 1.3 0 2.5.3 3.5.9zm-11.2 59.3c-1.8 3.2-3.9 6.4-6.1 9.6-3.7.3-7.4.4-11.2.4-3.9 0-7.6-.1-11.2-.4-2.2-3.2-4.2-6.4-6-9.6-1.9-3.3-3.7-6.7-5.3-10 1.6-3.3 3.4-6.7 5.3-10 1.8-3.2 3.9-6.4 6.1-9.6 3.7-.3 7.4-.4 11.2-.4 3.9 0 7.6.1 11.2.4 2.2 3.2 4.2 6.4 6 9.6 1.9 3.3 3.7 6.7 5.3 10-1.7 3.3-3.4 6.6-5.3 10zm8.3-3.3c1.5 3.5 2.7 6.9 3.8 10.3-3.4.8-7 1.4-10.8 1.9 1.2-1.9 2.5-3.9 3.6-6 1.2-2.1 2.3-4.2 3.4-6.2zm-25.6 27.1c-2.4-2.6-4.7-5.4-6.9-8.3 2.3.1 4.6.2 6.9.2 2.3 0 4.6-.1 6.9-.2-2.2 2.9-4.5 5.7-6.9 8.3zm-18.6-15c-3.8-.5-7.4-1.1-10.8-1.9 1.1-3.3 2.3-6.8 3.8-10.3 1.1 2 2.2 4.1 3.4 6.1 1.2 2.2 2.4 4.1 3.6 6.1zm-7-25.5c-1.5-3.5-2.7-6.9-3.8-10.3 3.4-.8 7-1.4 10.8-1.9-1.2 1.9-2.5 3.9-3.6 6-1.2 2.1-2.3 4.2-3.4 6.2zm25.6-27.1c2.4 2.6 4.7 5.4 6.9 8.3-2.3-.1-4.6-.2-6.9-.2-2.3 0-4.6.1-6.9.2 2.2-2.9 4.5-5.7 6.9-8.3zm22.2 21l-3.6-6c3.8.5 7.4 1.1 10.8 1.9-1.1 3.3-2.3 6.8-3.8 10.3-1.1-2.1-2.2-4.2-3.4-6.2zm-54.5-16.2c-1.7-10.5-.3-17.9 3.8-20.3 1-.6 2.2-.9 3.5-.9 6 0 13.5 4.9 21 12.3-3.5 3.8-7 8.2-10.4 13-5.8.5-11.3 1.4-16.5 2.5-.6-2.3-1-4.5-1.4-6.6zm-24.7 29c0-4.7 5.7-9.7 15.7-13.4 2-.8 4.2-1.5 6.4-2.1 1.6 5 3.6 10.3 6 15.6-2.4 5.3-4.5 10.5-6 15.5-13.8-4-22.1-10-22.1-15.6zm28.5 49.3c-4.1-2.4-5.5-9.8-3.8-20.3.3-2.1.8-4.3 1.4-6.6 5.2 1.2 10.7 2 16.5 2.5 3.4 4.8 6.9 9.1 10.4 13-7.4 7.3-14.9 12.3-21 12.3-1.3 0-2.5-.3-3.5-.9zm60.8-20.3c1.7 10.5.3 17.9-3.8 20.3-1 .6-2.2.9-3.5.9-6 0-13.5-4.9-21-12.3 3.5-3.8 7-8.2 10.4-13 5.8-.5 11.3-1.4 16.5-2.5.6 2.3 1 4.5 1.4 6.6zm9-15.6c-2 .8-4.2 1.5-6.4 2.1-1.6-5-3.6-10.3-6-15.6 2.4-5.3 4.5-10.5 6-15.5 13.8 4 22.1 10 22.1 15.6 0 4.7-5.8 9.7-15.7 13.4z',
  }),
  nextjs: RiNextjsFill,
  iOS: FaApple,
  netlify: BiLogoNetlify,
  angular: createIcon({
    viewBox: '0 0 128 128',
    displayName: 'ReactIcon',
    path: (
      <>
        <path
          fill="#B3B3B3"
          d="M63.81 1.026l-59.257 20.854 9.363 77.637 49.957 27.457 50.214-27.828 9.36-77.635z"
        />
        <path
          fill="#A6120D"
          d="M117.536 25.998l-53.864-18.369v112.785l45.141-24.983z"
        />
        <path
          fill="#DD1B16"
          d="M11.201 26.329l8.026 69.434 44.444 24.651v-112.787z"
        />
        <path
          fill="#F2F2F2"
          d="M78.499 67.67l-14.827 6.934h-15.628l-7.347 18.374-13.663.254 36.638-81.508 14.827 55.946zm-1.434-3.491l-13.295-26.321-10.906 25.868h10.807l13.394.453z"
        />
        <path
          fill="#B3B3B3"
          d="M63.671 11.724l.098 26.134 12.375 25.888h-12.446l-.027 10.841 17.209.017 8.042 18.63 13.074.242z"
        />
      </>
    ),
  }),
  android: createIcon({
    viewBox: '0 0 128 128',
    displayName: 'ReactIcon',
    path: (
      <>
        <path
          fill="#fff"
          d="M21.012 91.125c-5.538.003-10.038-4.503-10.039-10.04l-.002-30.739c-.002-5.532 4.497-10.037 10.028-10.038 2.689-.002 5.207 1.041 7.105 2.937s2.942 4.418 2.944 7.099l-.003 30.74c.007 2.679-1.034 5.199-2.931 7.094-1.892 1.9-4.417 2.946-7.102 2.947M21.004 43.005c-4.053-.002-7.338 3.291-7.339 7.341l.005 30.736c.001 4.064 3.292 7.344 7.341 7.348 4.057-.005 7.343-3.285 7.339-7.347v-30.741c-.002-4.049-3.291-7.339-7.346-7.337"
        />
        <path
          fill="#fff"
          d="M99.742 44.527l-2.698-.001-66.119.009-2.699.001-.002-2.699c-.006-11.08 6.03-21.385 15.917-27.473l-3.844-7.017c-.47-.822-.588-1.863-.314-2.815.278-.952.935-1.771 1.814-2.239.509-.288 1.131-.448 1.759-.447 1.362 0 2.609.739 3.267 1.933l4.023 7.329c4.163-1.527 8.558-2.306 13.099-2.305 4.606-.002 9.023.777 13.204 2.311l4.017-7.341c.647-1.191 1.903-1.933 3.263-1.932.612-.001 1.223.148 1.761.438.903.495 1.533 1.286 1.81 2.245.276.953.165 1.959-.318 2.832l-3.842 7.013c9.871 6.101 15.9 16.398 15.899 27.459l.003 2.699zM80.196 15.403l5.123-9.355c.273-.489.095-1.115-.399-1.386-.501-.271-1.119-.086-1.384.405l-5.176 9.45c-4.354-1.934-9.229-3.021-14.382-3.016-5.142-.005-10.008 1.078-14.349 3.005l-5.181-9.429c-.267-.497-.891-.679-1.379-.405-.497.266-.68.891-.403 1.379l5.125 9.348c-10.07 5.194-16.874 15.084-16.868 26.439l66.118-.008c.003-11.351-6.789-21.221-16.845-26.427m-31.256 14.457c-1.521-.003-2.763-1.241-2.763-2.771 0-1.523 1.24-2.774 2.766-2.774 1.533-.001 2.773 1.251 2.775 2.774.001 1.528-1.242 2.77-2.778 2.771m30.107-.006c-1.528.002-2.775-1.235-2.772-2.771 0-1.521 1.242-2.772 2.773-2.778 1.521.005 2.768 1.258 2.767 2.779 0 1.531-1.241 2.771-2.768 2.77M51.711 126.159c-5.533-.001-10.036-4.501-10.037-10.038l-.002-13.567-2.638.003c-2.817.001-5.461-1.094-7.448-3.082-1.99-1.986-3.087-4.633-3.083-7.452l-.01-47.627v-2.701h2.699l65.623-.01 2.7-.002v2.699l.007 47.633c.001 5.809-4.725 10.536-10.532 10.535l-2.654.002.003 13.562c0 5.534-4.502 10.039-10.033 10.039-2.681.006-5.197-1.036-7.098-2.937-1.901-1.896-2.948-4.416-2.947-7.096v-13.568h-4.511v13.565c-.002 5.535-4.503 10.043-10.039 10.042"
        />
        <path
          fill="#fff"
          d="M31.205 92.022c-.004 4.337 3.497 7.838 7.831 7.837h5.333l.006 16.264c-.001 4.05 3.289 7.341 7.335 7.342 4.056 0 7.342-3.295 7.338-7.348l.001-16.259 9.909-.003-.001 16.263c.004 4.051 3.298 7.346 7.343 7.338 4.056.003 7.344-3.292 7.343-7.344l-.005-16.259 5.353-.001c4.319.001 7.832-3.508 7.832-7.837l-.009-47.635-65.621.012.012 47.63zM106.996 91.112c-5.536.001-10.039-4.498-10.038-10.036l-.008-30.738c.002-5.537 4.498-10.041 10.031-10.041 5.54-.001 10.046 4.502 10.045 10.038l.003 30.736c.001 5.534-4.498 10.042-10.033 10.041M106.986 42.996c-4.053-.004-7.337 3.287-7.337 7.342l.003 30.737c.002 4.059 3.286 7.343 7.342 7.34 4.054-.001 7.335-3.281 7.338-7.343l-.008-30.736c-.001-4.056-3.283-7.342-7.338-7.34"
        />
        <path
          fill="#A4C439"
          d="M21.004 43.005c-4.053-.002-7.338 3.291-7.339 7.341l.005 30.736c.001 4.064 3.288 7.344 7.342 7.343 4.056 0 7.342-3.28 7.338-7.342v-30.741c-.002-4.049-3.291-7.339-7.346-7.337m59.192-27.602l5.123-9.355c.273-.489.094-1.111-.401-1.388-.5-.265-1.117-.085-1.382.407l-5.175 9.453c-4.354-1.938-9.227-3.024-14.383-3.019-5.142-.005-10.013 1.078-14.349 3.005l-5.181-9.429c-.269-.497-.889-.677-1.378-.406-.498.269-.681.892-.404 1.38l5.125 9.349c-10.07 5.193-16.874 15.083-16.868 26.438l66.118-.008c.003-11.351-6.789-21.221-16.845-26.427m-31.256 14.457c-1.521-.003-2.763-1.241-2.763-2.771 0-1.523 1.238-2.775 2.766-2.774 1.533-.001 2.773 1.251 2.775 2.774.001 1.528-1.242 2.77-2.778 2.771m30.107-.006c-1.528.002-2.772-1.237-2.772-2.771.006-1.52 1.242-2.772 2.773-2.778 1.521.005 2.768 1.258 2.767 2.779.002 1.531-1.241 2.771-2.768 2.77m-47.854 14.538l.011 47.635c-.003 4.333 3.502 7.831 7.832 7.831l5.333.002.006 16.264c-.001 4.05 3.291 7.342 7.335 7.342 4.056 0 7.342-3.295 7.343-7.347l-.004-16.26 9.909-.003.004 16.263c0 4.047 3.293 7.346 7.338 7.338 4.056.003 7.344-3.292 7.343-7.344l-.005-16.259 5.352-.004c4.32.002 7.834-3.5 7.836-7.834l-.009-47.635-65.624.011zm83.134 5.943c-.001-4.055-3.286-7.341-7.341-7.339-4.053-.004-7.337 3.287-7.337 7.342l.006 30.738c-.001 4.058 3.283 7.338 7.339 7.339 4.054-.001 7.337-3.281 7.338-7.343l-.005-30.737z"
        />
      </>
    ),
  }),
  javascript: createIcon({
    viewBox: '0 0 128 128',
    displayName: 'ReactIcon',
    path: (
      <>
        <path fill="#F0DB4F" d="M1.408 1.408h125.184v125.185h-125.184z" />
        <path
          fill="#323330"
          d="M116.347 96.736c-.917-5.711-4.641-10.508-15.672-14.981-3.832-1.761-8.104-3.022-9.377-5.926-.452-1.69-.512-2.642-.226-3.665.821-3.32 4.784-4.355 7.925-3.403 2.023.678 3.938 2.237 5.093 4.724 5.402-3.498 5.391-3.475 9.163-5.879-1.381-2.141-2.118-3.129-3.022-4.045-3.249-3.629-7.676-5.498-14.756-5.355l-3.688.477c-3.534.893-6.902 2.748-8.877 5.235-5.926 6.724-4.236 18.492 2.975 23.335 7.104 5.332 17.54 6.545 18.873 11.531 1.297 6.104-4.486 8.08-10.234 7.378-4.236-.881-6.592-3.034-9.139-6.949-4.688 2.713-4.688 2.713-9.508 5.485 1.143 2.499 2.344 3.63 4.26 5.795 9.068 9.198 31.76 8.746 35.83-5.176.165-.478 1.261-3.666.38-8.581zm-46.885-37.793h-11.709l-.048 30.272c0 6.438.333 12.34-.714 14.149-1.713 3.558-6.152 3.117-8.175 2.427-2.059-1.012-3.106-2.451-4.319-4.485-.333-.584-.583-1.036-.667-1.071l-9.52 5.83c1.583 3.249 3.915 6.069 6.902 7.901 4.462 2.678 10.459 3.499 16.731 2.059 4.082-1.189 7.604-3.652 9.448-7.401 2.666-4.915 2.094-10.864 2.07-17.444.06-10.735.001-21.468.001-32.237z"
        />
      </>
    ),
  }),
  vuejs: createIcon({
    viewBox: '0 0 128 128',
    displayName: 'ReactIcon',
    path: (
      <>
        <path
          d="m-2.3125e-8 8.9337 49.854 0.1586 14.167 24.47 14.432-24.47 49.547-0.1577-63.834 110.14zm126.98 0.6374-24.36 0.0207-38.476 66.052-38.453-66.052-24.749-0.0194 63.211 107.89zm-25.149-0.008-22.745 0.16758l-15.053 24.647-14.817-24.647-22.794-0.1679 37.731 64.476zM25.997 9.3929l23.002 0.0087M25.997 9.3929l23.002 0.0087"
          fill="none"
        />
        <path
          d="m25.997 9.3929 23.002 0.0087l15.036 24.958 14.983-24.956 22.982-0.0057-37.85 65.655z"
          fill="#35495e"
        />
        <path
          d="m0.91068 9.5686 25.066-0.1711 38.151 65.658 37.852-65.654 25.11 0.0263-62.966 108.06z"
          fill="#41b883"
        />
      </>
    ),
  }),
  nodejs: createIcon({
    viewBox: '0 0 128 128',
    displayName: 'ReactIcon',
    path: (
      <>
        <path
          fill="#83CD29"
          d="M114.325 80.749c-.29 0-.578-.076-.832-.224l-2.65-1.568c-.396-.221-.203-.3-.072-.345.528-.184.635-.227 1.198-.545.059-.033.136-.021.197.015l2.035 1.209c.074.041.179.041.246 0l7.937-4.581c.075-.042.122-.127.122-.215v-9.16c0-.09-.047-.173-.123-.219l-7.934-4.577c-.074-.042-.171-.042-.245 0l-7.933 4.578c-.076.045-.125.131-.125.218v9.16c0 .088.049.171.125.212l2.174 1.257c1.18.589 1.903-.105 1.903-.803v-9.045c0-.127.103-.228.23-.228h1.007c.125 0 .229.101.229.228v9.045c0 1.574-.857 2.477-2.35 2.477-.459 0-.82 0-1.828-.496l-2.081-1.198c-.515-.298-.832-.854-.832-1.448v-9.16c0-.595.317-1.15.832-1.446l7.937-4.587c.502-.283 1.169-.283 1.667 0l7.937 4.587c.514.297.833.852.833 1.446v9.16c0 .595-.319 1.148-.833 1.448l-7.937 4.582c-.252.147-.539.223-.834.223M116.778 74.438c-3.475 0-4.202-1.595-4.202-2.932 0-.126.103-.229.23-.229h1.026c.115 0 .21.082.228.194.154 1.045.617 1.572 2.718 1.572 1.671 0 2.383-.378 2.383-1.266 0-.512-.202-.891-2.8-1.146-2.172-.215-3.515-.694-3.515-2.433 0-1.601 1.35-2.557 3.612-2.557 2.543 0 3.801.883 3.96 2.777.006.064-.017.127-.06.176-.044.045-.104.073-.168.073h-1.031c-.107 0-.201-.075-.223-.179-.248-1.1-.848-1.451-2.479-1.451-1.825 0-2.037.637-2.037 1.112 0 .577.25.745 2.715 1.071 2.439.323 3.598.779 3.598 2.494.001 1.733-1.441 2.724-3.955 2.724"
        />
        <path
          fill="#404137"
          d="M97.982 68.43c.313-.183.506-.517.506-.88v-2.354c0-.362-.192-.696-.506-.879l-8.364-4.856c-.315-.183-.703-.184-1.019-.002l-8.416 4.859c-.314.182-.508.517-.508.88v9.716c0 .365.196.703.514.884l8.363 4.765c.308.177.686.178.997.006l5.058-2.812c.161-.09.261-.258.262-.44.001-.184-.097-.354-.256-.445l-8.468-4.86c-.159-.091-.256-.259-.256-.44v-3.046c0-.182.097-.349.254-.439l2.637-1.52c.156-.091.35-.091.507 0l2.637 1.52c.158.091.255.258.255.439v2.396c0 .183.097.351.254.441.158.091.352.091.51-.001l5.039-2.932"
        />
        <path
          fill="#83CD29"
          d="M88.984 67.974c.061-.034.135-.034.195 0l1.615.933c.06.035.097.1.097.169v1.865c0 .07-.037.134-.097.169l-1.615.932c-.06.035-.135.035-.195 0l-1.614-.932c-.061-.035-.098-.099-.098-.169v-1.865c0-.069.037-.134.098-.169l1.614-.933"
        />
        <path
          fill="#404137"
          d="M67.083 71.854c0 .09-.048.174-.127.22l-2.89 1.666c-.079.046-.176.046-.254 0l-2.89-1.666c-.079-.046-.127-.13-.127-.22v-3.338c0-.09.049-.175.127-.221l2.89-1.668c.079-.047.176-.047.255 0l2.891 1.668c.078.046.126.131.126.221v3.338zm.781-24.716c-.157-.087-.349-.085-.505.006-.155.092-.251.258-.251.438v12.915c0 .126-.068.244-.177.308-.11.063-.246.063-.356 0l-2.108-1.215c-.314-.181-.701-.181-1.015 0l-8.418 4.858c-.315.182-.509.518-.509.881v9.719c0 .363.194.698.508.881l8.418 4.861c.314.182.702.182 1.017 0l8.42-4.861c.314-.183.508-.518.508-.881v-24.227c0-.368-.2-.708-.521-.888l-5.011-2.795"
        />
        <path
          fill="#83CD29"
          d="M38.238 59.407c.314-.182.702-.182 1.016 0l8.418 4.857c.314.182.508.518.508.881v9.722c0 .363-.194.699-.508.881l-8.417 4.861c-.314.181-.702.181-1.017 0l-8.415-4.861c-.314-.182-.508-.518-.508-.881v-9.723c0-.362.194-.698.508-.88l8.415-4.857"
        />
        <path
          fill="#404137"
          d="M22.93 65.064c0-.366-.192-.702-.508-.883l-8.415-4.843c-.144-.084-.303-.127-.464-.133h-.087c-.16.006-.32.049-.464.133l-8.416 4.843c-.313.181-.509.517-.509.883l.018 13.04c0 .182.095.351.254.439.156.094.349.094.505 0l5-2.864c.316-.188.509-.519.509-.882v-6.092c0-.364.192-.699.507-.881l2.13-1.226c.158-.093.332-.137.508-.137.174 0 .352.044.507.137l2.128 1.226c.315.182.509.517.509.881v6.092c0 .363.195.696.509.882l5 2.864c.157.094.353.094.508 0 .155-.089.252-.258.252-.439l.019-13.04"
        />
      </>
    ),
  }),
  python: createIcon({
    viewBox: '0 0 128 128',
    displayName: 'ReactIcon',
    path: (
      <>
        <path
          fill="#646464"
          d="M63.391 1.988c-4.222.02-8.252.379-11.8 1.007-10.45 1.846-12.346 5.71-12.346 12.837v9.411h24.693v3.137h-33.961c-7.176 0-13.46 4.313-15.426 12.521-2.268 9.405-2.368 15.275 0 25.096 1.755 7.311 5.947 12.519 13.124 12.519h8.491v-11.282c0-8.151 7.051-15.34 15.426-15.34h24.665c6.866 0 12.346-5.654 12.346-12.548v-23.513c0-6.693-5.646-11.72-12.346-12.837-4.244-.706-8.645-1.027-12.866-1.008zm-13.354 7.569c2.55 0 4.634 2.117 4.634 4.721 0 2.593-2.083 4.69-4.634 4.69-2.56 0-4.633-2.097-4.633-4.69-.001-2.604 2.073-4.721 4.633-4.721z"
        />
        <path
          fill="#FFD845"
          d="M91.682 28.38v10.966c0 8.5-7.208 15.655-15.426 15.655h-24.665c-6.756 0-12.346 5.783-12.346 12.549v23.515c0 6.691 5.818 10.628 12.346 12.547 7.816 2.297 15.312 2.713 24.665 0 6.216-1.801 12.346-5.423 12.346-12.547v-9.412h-24.664v-3.138h37.012c7.176 0 9.852-5.005 12.348-12.519 2.578-7.735 2.467-15.174 0-25.096-1.774-7.145-5.161-12.521-12.348-12.521h-9.268zm-13.873 59.547c2.561 0 4.634 2.097 4.634 4.692 0 2.602-2.074 4.719-4.634 4.719-2.55 0-4.633-2.117-4.633-4.719 0-2.595 2.083-4.692 4.633-4.692z"
        />
        <path
          opacity=".444"
          fill="url(#c)"
          enableBackground="new"
          d="M97.309 119.597c0 3.543-14.816 6.416-33.091 6.416-18.276 0-33.092-2.873-33.092-6.416 0-3.544 14.815-6.417 33.092-6.417 18.275 0 33.091 2.872 33.091 6.417z"
        />
      </>
    ),
  }),
  php: createIcon({
    viewBox: '0 0 128 128',
    displayName: 'ReactIcon',
    path: (
      <>
        <path d="M64.026 96.076c33.676 0 60.976-14.361 60.976-32.076s-27.3-32.075-60.976-32.075-60.975 14.36-60.975 32.075 27.3 32.076 60.975 32.076" />
        <path d="M2.998 31.924h122.004v64.1h-122.004z" />
        <path d="M2.998 31.924h122.004v64.1h-122.004z" />
        <path
          fill="#6181B6"
          d="M64.026 93.694c32.36 0 58.594-13.295 58.594-29.694s-26.233-29.694-58.594-29.694-58.593 13.295-58.593 29.694 26.233 29.694 58.593 29.694z"
        />
        <path
          fill="#fff"
          d="M75.896 73.598l2.906-14.958c.656-3.377.11-5.896-1.62-7.486-1.677-1.54-4.523-2.288-8.703-2.288h-5.033l1.44-7.412c.055-.279-.02-.568-.2-.788-.181-.219-.45-.347-.735-.347h-6.947c-.456 0-.848.323-.936.771l-3.086 15.881c-.28-1.787-.973-3.323-2.079-4.591-2.038-2.332-5.261-3.515-9.58-3.515h-13.467c-.456 0-.848.322-.935.771l-6.247 32.144c-.055.278.02.568.2.787.181.22.451.347.735.347h7.002c.456 0 .849-.323.936-.771l1.511-7.775h5.213c2.735 0 5.032-.296 6.827-.881 1.834-.596 3.522-1.607 5.011-3.001 1.202-1.104 2.196-2.341 2.96-3.676l-1.248 6.424c-.054.278.02.567.2.787s.451.347.735.347h6.947c.456 0 .848-.323.936-.771l3.429-17.645h4.767c2.031 0 2.626.404 2.787.578.147.159.452.718.11 2.48l-2.764 14.223c-.055.278.019.567.2.787.181.22.45.347.735.347h7.058c.455.001.848-.322.935-.769zm-32.208-12.36c-.437 2.242-1.259 3.842-2.444 4.755-1.205.927-3.132 1.397-5.727 1.397h-3.104l2.244-11.548h4.012c2.948 0 4.136.63 4.612 1.158.662.734.802 2.199.407 4.238zM105.604 52.38c-2.038-2.332-5.261-3.515-9.581-3.515h-13.464c-.456 0-.849.322-.936.771l-6.248 32.144c-.054.278.02.568.201.787.181.22.45.347.734.347h7.003c.455 0 .848-.323.935-.771l1.512-7.775h5.212c2.735 0 5.033-.296 6.827-.881 1.835-.596 3.522-1.607 5.011-3.001 1.241-1.141 2.264-2.421 3.037-3.806.772-1.383 1.328-2.927 1.65-4.588.797-4.094.16-7.363-1.893-9.712zm-7.262 8.858c-.437 2.242-1.259 3.842-2.444 4.755-1.204.927-3.131 1.397-5.727 1.397h-3.104l2.245-11.548h4.012c2.948 0 4.136.63 4.612 1.158.662.734.801 2.199.406 4.238z"
        />
        <path
          fill="#000004"
          d="M38.67 54.89c2.66 0 4.434.491 5.32 1.474.885.982 1.097 2.668.633 5.057-.484 2.488-1.416 4.264-2.798 5.328-1.382 1.063-3.485 1.595-6.308 1.595h-4.26l2.614-13.453h4.799v-.001zm-17.061 27.072h7.002l1.661-8.546h5.998c2.646 0 4.823-.277 6.532-.834 1.709-.556 3.263-1.488 4.661-2.797 1.173-1.078 2.122-2.268 2.85-3.569.727-1.3 1.242-2.734 1.547-4.305.741-3.811.182-6.778-1.676-8.904s-4.812-3.189-8.862-3.189h-13.466l-6.247 32.144zM57.003 41.271h6.947l-1.661 8.546h6.189c3.894 0 6.58.68 8.059 2.037 1.479 1.359 1.921 3.561 1.33 6.603l-2.906 14.959h-7.058l2.763-14.223c.314-1.618.199-2.722-.347-3.311-.546-.587-1.708-.882-3.485-.882h-5.553l-3.578 18.416h-6.947l6.247-32.145zM93.324 54.89c2.66 0 4.434.491 5.319 1.474.887.982 1.097 2.668.634 5.057-.484 2.488-1.417 4.264-2.799 5.328-1.382 1.063-3.484 1.595-6.308 1.595h-4.259l2.614-13.453h4.799v-.001zm-17.06 27.072h7.002l1.661-8.546h5.997c2.646 0 4.823-.277 6.532-.834 1.71-.556 3.264-1.488 4.661-2.797 1.174-1.078 2.123-2.268 2.851-3.569.726-1.3 1.242-2.734 1.547-4.305.74-3.811.182-6.778-1.676-8.904s-4.812-3.189-8.863-3.189h-13.465l-6.247 32.144z"
        />
      </>
    ),
  }),
  dotNet: createIcon({
    viewBox: '0 0 128 128',
    displayName: 'ReactIcon',
    path: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1384C8"
        d="M82.108 78.432c.479-1.232 1.022-2.445 1.427-3.701 2.288-7.097 4.554-14.2 6.805-21.309.865-2.731 1.813-5.42 3.515-7.767 2.692-3.709 6.442-5.652 10.88-6.331 1.741-.266 3.518-.389 5.28-.406 5.267-.05 10.536-.015 15.804-.01.28 0 .56.029.957.052-.129.304-.199.525-.311.724-1.955 3.494-3.872 7.009-5.885 10.468-3.505 6.022-7.016 12.042-10.631 17.998-2.319 3.819-4.834 7.52-7.687 10.974-2.105 2.548-4.321 4.984-7.146 6.77-1.925 1.217-3.981 1.929-6.315 1.917-8.278-.045-16.556-.012-24.834-.024-2.461-.004-4.568-.941-6.356-2.603-2.563-2.381-4.093-5.412-5.345-8.608-2.284-5.835-3.563-11.951-5.031-18.014-.688-2.838-1.47-5.654-2.215-8.478-.048-.183-.142-.354-.25-.617l-.577.542c-3.228 3.207-6.071 6.741-8.615 10.498-.693 1.024-.926 2.374-1.313 3.591-1.424 4.47-2.722 8.983-4.264 13.411-1.477 4.242-4.125 7.616-8.264 9.61-2.42 1.165-5.004 1.795-7.689 1.855-3.98.088-7.962.098-11.943.134-.952.009-.996-.069-.748-.99 1.707-6.338 3.87-12.514 6.58-18.492 2.794-6.167 6.085-12.048 10.231-17.419 2.823-3.657 5.941-7.031 9.843-9.582 1.979-1.293 4.083-2.315 6.477-2.584.394-.045.793-.073 1.189-.073 8.478-.004 16.956.082 25.433-.039 4.547-.065 7.839 1.855 10.304 5.515 1.533 2.276 2.63 4.761 3.553 7.328 1.861 5.178 3.018 10.547 4.325 15.878.748 3.051 1.581 6.081 2.379 9.12.06.228.157.446.238.668l.199-.006z"
      />
    ),
  }),
  java: createIcon({
    viewBox: '0 0 128 128',
    displayName: 'ReactIcon',
    path: (
      <>
        <path
          fill="#0074BD"
          d="M47.617 98.12s-4.767 2.774 3.397 3.71c9.892 1.13 14.947.968 25.845-1.092 0 0 2.871 1.795 6.873 3.351-24.439 10.47-55.308-.607-36.115-5.969zM44.629 84.455s-5.348 3.959 2.823 4.805c10.567 1.091 18.91 1.18 33.354-1.6 0 0 1.993 2.025 5.132 3.131-29.542 8.64-62.446.68-41.309-6.336z"
        />
        <path
          fill="#EA2D2E"
          d="M69.802 61.271c6.025 6.935-1.58 13.17-1.58 13.17s15.289-7.891 8.269-17.777c-6.559-9.215-11.587-13.792 15.635-29.58 0 .001-42.731 10.67-22.324 34.187z"
        />
        <path
          fill="#0074BD"
          d="M102.123 108.229s3.529 2.91-3.888 5.159c-14.102 4.272-58.706 5.56-71.094.171-4.451-1.938 3.899-4.625 6.526-5.192 2.739-.593 4.303-.485 4.303-.485-4.953-3.487-32.013 6.85-13.743 9.815 49.821 8.076 90.817-3.637 77.896-9.468zM49.912 70.294s-22.686 5.389-8.033 7.348c6.188.828 18.518.638 30.011-.326 9.39-.789 18.813-2.474 18.813-2.474s-3.308 1.419-5.704 3.053c-23.042 6.061-67.544 3.238-54.731-2.958 10.832-5.239 19.644-4.643 19.644-4.643zM90.609 93.041c23.421-12.167 12.591-23.86 5.032-22.285-1.848.385-2.677.72-2.677.72s.688-1.079 2-1.543c14.953-5.255 26.451 15.503-4.823 23.725 0-.002.359-.327.468-.617z"
        />
        <path
          fill="#EA2D2E"
          d="M76.491 1.587s12.968 12.976-12.303 32.923c-20.266 16.006-4.621 25.13-.007 35.559-11.831-10.673-20.509-20.07-14.688-28.815 8.548-12.834 32.229-19.059 26.998-39.667z"
        />
        <path
          fill="#0074BD"
          d="M52.214 126.021c22.476 1.437 57-.8 57.817-11.436 0 0-1.571 4.032-18.577 7.231-19.186 3.612-42.854 3.191-56.887.874 0 .001 2.875 2.381 17.647 3.331z"
        />
      </>
    ),
  }),
  ror: createIcon({
    viewBox: '0 0 128 128',
    displayName: 'ReactIcon',
    path: (
      <>
        <path
          fill="#A62C39"
          d="M17.444 125.054s.188-29.538.188-59.564c0-58.159-4.901-62.491 21.194-62.491h72.635v83.889c0 27.615 5.162 38.433-23.859 38.433-29.021.001-70.158-.267-70.158-.267z"
        />
        <path
          fill="url(#a)"
          d="M350.603 449.926s4.655.932 8.688 7.757c4.034 6.826 25.444 59.886 25.444 59.886v-43.131l-19.858-32.27 5.585 6.827 10.55-8.689-13.653-.93-16.756 10.55z"
        />
        <path
          opacity=".668"
          fill="url(#b)"
          enableBackground="new"
          d="M309.335 439.686s30.719 20.479 45.613 24.513c14.894 4.035 30.408 8.378 30.408 8.378l-35.373 86.88 15.204.621 19.86-49.026-.622-71.676-75.09.31z"
        />
        <path
          fill="#fff"
          fillOpacity=".44"
          d="M337.881 531.221l31.956 30.733-59.571-1.256s-1.861-18.927-1.241-28.856l3.723-9.929 25.133 9.308z"
        />
        <path
          fillOpacity=".362"
          d="M94.085 125.365l-28.856-29.788-26.375-9.929-20.479-45.612 21.721-36.304-14.584-.621-5.896 5.586-2.172 4.344-1.552 112.945 78.193-.621z"
        />
        <path
          opacity=".5"
          fill="#83222D"
          enableBackground="new"
          d="M111.773 77.89s-29.167 9.309-46.543 17.997c-17.376 8.688-26.685 29.787-26.685 29.787s37.234-1.861 51.197-1.241c13.963.621 20.479.621 21.72-18.927 1.241-19.548.311-27.616.311-27.616z"
        />
        <path d="M26.435 96.422v18.326h4.674v-4.773l4.254 4.254h7.172l-5.688-5.688s4.093-.067 4.402-5.984c0-5.43-4.097-6.134-8.83-6.134h-5.984zm4.897 4.971h4.031v3.265h-4.031v-3.265z" />
        <path d="M51.562 96.496c-2.559-.015-6.108.223-6.108 5.045v12.737h4.797v-3.116h4.65v3.042h4.822v-13.354c0-4.189-4.654-4.353-7.147-4.353l-1.014-.001zm-1.237 4.6h4.501v5.021h-4.501v-5.021z" />
        <path d="M64.531 96.507h4.964v17.531h-4.964z" />
        <path d="M74.692 96.741v17.531h11.947v-4.654h-7.059v-12.955l-4.888.078z" />
        <path d="M102.463 96.585v4.732h-7.99v1.707h3.413c1.785 0 5.508-.077 5.508 5.508s-2.561 5.896-7.758 5.896h-6.283v-4.267h7.214c2.172 0 2.292-.708 2.292-1.324 0-.615-1.11-.902-3.369-.902s-6.447-1.11-6.447-5.454 2.172-5.973 6.516-5.973c4.345-.001 6.904.077 6.904.077z" />
        <path d="M30.787 91.233h41.269s-9.154-20.789-6.826-39.873c2.326-19.082 17.376-27.771 25.909-28.702 8.533-.931 13.187 4.344 13.187 4.344l1.861-2.792s-12.256-12.412-27.771-11.015c-15.514 1.395-26.219 11.635-32.89 24.046-6.671 12.412-10.55 21.101-13.188 34.132-2.637 13.033-1.551 19.86-1.551 19.86z" />
        <path d="M22.565 70.444l8.066.62-1.396 8.068-7.602-.931.932-7.757z" />
        <path d="M35.286 53.377l2.172-6.05-7.137-2.793-2.327 6.516 7.292 2.327z" />
        <path d="M45.37 32.588l4.189-4.965-5.43-3.568-4.343 4.81 5.584 3.723z" />
        <path d="M56.385 13.351l3.724 4.499 5.12-2.947-3.724-4.189-5.12 2.637z" />
        <path d="M74.538 8.231l.93 4.499 6.361-.155-.62-4.034-6.671-.31z" />
        <path d="M96.102 13.04l-.155 2.792 4.343 2.328.931-1.396-5.119-3.724z" />
        <path d="M95.172 24.986v2.327l4.189.465v-1.861l-4.189-.931z" />
        <path d="M81.829 27.002l2.017 3.724 2.948-2.327-.621-2.482-4.344 1.085z" />
        <path d="M75.468 31.812l3.103 4.655-1.862 3.257-4.499-4.965 3.258-2.947z" />
        <path d="M69.262 44.69l-2.017 4.033 5.275 4.5 1.241-5.121-4.499-3.412z" />
        <path d="M67.09 58.807l-.31 5.43 6.516 2.792-.311-5.119-5.895-3.103z" />
        <path d="M68.952 78.045l1.552 5.586 8.223.465-2.949-6.051h-6.826z" />
        <path
          stroke="#5E000E"
          strokeWidth="3"
          d="M17.444 125.054s.188-29.538.188-59.564c0-58.159-4.901-62.491 21.194-62.491h72.635v83.889c0 27.615 3.921 38.433-23.859 38.433-27.78.001-70.158-.267-70.158-.267z"
          fill="none"
        />
      </>
    ),
  }),
  shopify: createIcon({
    viewBox: '0 0 493.73 493.73',
    displayName: 'ReactIcon',
    path: (
      <>
        <path
          d="M404.936 92.136c-1.768-.168-39.52-2.968-39.52-2.968S339.176 63 336.304 60.12c-2.88-2.896-8.504-2.032-10.696-1.368-.312.088-5.72 1.776-14.672 4.536-8.768-25.336-24.216-48.616-51.408-48.616-.752 0-1.528.032-2.312.08C249.488 4.488 239.904 0 231.624 0 168.272 0 138 79.608 128.512 120.064c-24.624 7.648-42.128 13.104-44.336 13.824-13.768 4.336-14.192 4.768-15.976 17.776-1.376 9.848-37.336 289.312-37.336 289.312l280.176 52.752 151.824-33.016S409.576 98.624 409.24 96.136c-.336-2.48-2.512-3.856-4.304-4zm-149.8-14.232c0 .952-.016 1.848-.016 2.752-15.424 4.808-32.16 10.008-48.968 15.248 9.432-36.56 27.096-54.24 42.56-60.904 3.88 9.808 6.424 23.904 6.424 42.904zm-25.264-60.816c2.768 0 5.504.928 8.144 2.76-20.312 9.592-42.064 33.792-51.264 82.088-13.432 4.176-26.552 8.272-38.704 12.048 10.768-36.856 36.32-96.896 81.824-96.896zm10.92 215.296s-16.4-8.792-36.488-8.792c-29.488 0-30.976 18.592-30.976 23.264 0 25.56 66.296 35.36 66.296 95.224 0 47.104-29.712 77.424-69.808 77.424-48.096 0-72.704-30.088-72.704-30.088l12.872-42.76s25.28 21.832 46.64 21.832c13.92 0 19.592-11.04 19.592-19.096 0-33.344-54.392-34.832-54.392-89.624 0-46.088 32.928-90.728 99.424-90.728 25.592 0 38.264 7.384 38.264 7.384l-18.72 55.96zm30.952-156.896c0-1.688.016-3.336.016-5.152 0-15.728-2.184-28.408-5.672-38.456 14.016 1.752 23.352 17.784 29.36 36.224-7.032 2.208-15.032 4.688-23.704 7.384z"
          fill="#95c675"
        />
        <path
          d="M404.936 92.136c-1.768-.168-39.52-2.968-39.52-2.968S339.176 63 336.304 60.12c-2.88-2.896-8.504-2.032-10.696-1.368-.312.088-5.72 1.776-14.672 4.536-8.768-25.336-24.216-48.616-51.408-48.616-.752 0-1.528.032-2.312.08C249.488 4.488 239.904 0 231.624 0c-63.352 0-78.984 79.608-88.472 120.064-24.624 7.648-43.52 49.752-45.752 50.456-13.752 4.336-14.176 4.768-15.968 17.784-1.384 9.84-50.568 252.672-50.568 252.672l280.176 52.752 151.824-33.016S409.576 98.624 409.24 96.136c-.336-2.48-2.512-3.856-4.304-4zm-149.8-14.232c0 .952-.016 1.848-.016 2.752-15.424 4.808-32.16 10.008-48.968 15.248 9.432-36.56 27.096-54.24 42.56-60.904 3.88 9.808 6.424 23.904 6.424 42.904zm-25.264-60.816c2.768 0 5.504.928 8.144 2.76-20.312 9.592-42.064 33.792-51.264 82.088-13.432 4.176-26.552 8.272-38.704 12.048 10.768-36.856 36.32-96.896 81.824-96.896zm10.92 215.296s-16.4-8.792-36.488-8.792c-29.488 0-30.976 18.592-30.976 23.264 0 25.56 66.296 35.36 66.296 95.224 0 47.104-29.712 77.424-69.808 77.424-48.096 0-72.704-30.088-72.704-30.088l12.872-42.76s25.28 21.832 46.64 21.832c13.92 0 19.592-11.04 19.592-19.096 0-33.344-54.392-34.832-54.392-89.624 0-46.088 32.928-90.728 99.424-90.728 25.592 0 38.264 7.384 38.264 7.384l-18.72 55.96zm30.952-156.896c0-1.688.016-3.336.016-5.152 0-15.728-2.184-28.408-5.672-38.456 14.016 1.752 23.352 17.784 29.36 36.224-7.032 2.208-15.032 4.688-23.704 7.384z"
          fill="#79b259"
        />
        <path
          d="m311.04 493.72 151.82-33.008s-53.288-362.09-53.624-364.58-2.504-3.856-4.304-4c-1.768-0.168-39.52-2.968-39.52-2.968s-26.24-26.168-29.112-29.048c-1.536-1.552-3.832-1.992-6-2.008-5.76 9.76-4.568 28.296-4.568 28.296l-17.856 406.71 3.16 0.6z"
          fill="#55932c"
        />
        <path
          d="M259.528 14.68c-.752 0-1.528.032-2.312.08C249.488 4.496 239.904.008 231.624.008c-63.096 0-93.392 78.984-103 119.576l19.576-6.072c10.832-36.872 36.36-96.424 81.672-96.424 2.768 0 5.504.928 8.144 2.76-20.256 9.56-41.952 33.672-51.184 81.704l19.44-6C215.728 59.224 233.32 41.64 248.728 35c3.872 9.816 6.424 23.904 6.424 42.904 0 .864 0 1.688-.016 2.512l16.624-5.144c0-1.6.016-3.2.016-4.936 0-15.728-2.184-28.408-5.672-38.456 13.968 1.744 23.296 17.704 29.296 36.064l15.504-4.808c-8.792-25.264-24.232-48.456-51.376-48.456z"
          fill="#4a7a2b"
        />
        <path
          d="M371.752 89.648c-3.792-.296-6.344-.48-6.344-.48S339.168 63 336.296 60.12c-1.536-1.552-3.832-1.992-6-2.008-5.76 9.76-4.568 28.296-4.568 28.296L307.872 493.12l3.168.6 80.784-17.568-20.072-386.504z"
          fill="#4c822a"
        />
      </>
    ),
  }),
  wordpress: createIcon({
    viewBox: '0 0 447.67 447.67',
    displayName: 'ReactIcon',
    path: (
      <>
        <path
          d="m134.29 138.16h-24.722l67.399 190.52 37.732-107.82-29.254-82.696h-26.084v-18.154h115.51v18.154h-27.049l67.398 190.52 24.227-69.234c31.781-88.702-26.048-116.33-26.048-136.13s16.048-35.843 35.843-35.843c1.071 0 2.111 0.058 3.13 0.153-33.541-31.663-78.768-51.08-128.53-51.08-65.027 0-122.31 33.146-155.88 83.458h66.336v18.154h2e-3zm-97.741 85.677c0 71.704 40.302 133.99 99.483 165.46l-84.52-238.92c-9.628 22.556-14.963 47.385-14.963 73.461zm350.28-92.29c2.679 15.774 1.868 33.503-2.243 51.301h0.745l-2.832 8.092c-1.678 5.843-3.791 11.82-6.191 17.693l-64.444 180.54c59.057-31.51 99.256-93.725 99.256-165.34 0-33.557-8.834-65.048-24.291-92.289z"
          fill="#00769d"
        />
        <path
          d="m166.08 402.03c18.195 5.894 37.603 9.091 57.762 9.091 19.228 0 37.777-2.902 55.239-8.285l-54.784-154.86-58.217 154.06z"
          fill="#00769d"
        />
        <path
          d="m382.11 65.56c-42.277-42.277-98.488-65.56-158.28-65.56s-116 23.283-158.28 65.56-65.56 98.487-65.56 158.28c0 59.789 23.283 116 65.56 158.28s98.488 65.56 158.28 65.56 116-23.283 158.28-65.56c42.277-42.277 65.56-98.488 65.56-158.28-1e-3 -59.79-23.284-116-65.561-158.28zm-158.28 366.32c-114.72 0-208.05-93.329-208.05-208.05s93.329-208.05 208.05-208.05 208.05 93.33 208.05 208.05-93.328 208.05-208.05 208.05z"
          fill="#00769d"
        />
      </>
    ),
  }),
  magento: createIcon({
    viewBox: '0 0 512 512',
    displayName: 'ReactIcon',
    path: (
      <>
        <path
          d="M512 256c0 48.797-13.657 94.407-37.355 133.214a256.975 256.975 0 0 1-55.965 64.449 252.753 252.753 0 0 1-6.959 5.528 255.604 255.604 0 0 1-62.307 35.234C320.481 505.772 288.966 512 256 512s-64.47-6.228-93.414-17.575c-22.497-8.819-43.436-20.741-62.307-35.223a257.247 257.247 0 0 1-62.924-69.977C13.657 350.417 0 304.797 0 256 0 114.615 114.615 0 256 0c61.785 0 118.45 21.88 162.68 58.337C475.669 105.284 512 176.4 512 256z"
          fill="#f0efeb"
        />
        <path
          d="M349.414 244.266v250.159C320.481 505.772 288.966 512 256 512s-64.47-6.228-93.414-17.575V244.266l60.813-35.119v250.044L256 478.02l32.601-18.829V209.147l60.813 35.119z"
          fill="#f36306"
        />
        <path
          d="m474.64 171.96v217.26a256.98 256.98 0 0 1-55.965 64.449 252.75 252.75 0 0 1-6.959 5.528v-250.9l-155.72-89.903-155.72 89.903v250.91a257.25 257.25 0 0 1-62.924-69.977v-217.26l218.64-126.21 218.64 126.21z"
          fill="#f36306"
        />
      </>
    ),
  }),
  go: SiGo,
}

export { UrlEndpointsSidebarGraphic, UrlEndpointsHomeGraphic, sdkIcons };

